import { App } from "app"
import ReactDOM from "react-dom"
import { HelmetProvider } from "react-helmet-async"
import { HashRouter } from "react-router-dom"
import { ThemeConfig } from "theme"
import { GlobalStyles } from "theme/global-styles"
import { RootStoreProvider, rootStore } from "stores/root-store"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { ErrorFallback } from "components/common/error-fallback"
import { ErrorBoundary } from "react-error-boundary"
import { LoggingHelper } from "utils/logging-helper"
import { LoggingLevel } from "shared/constants/logging-level"
import { initAnalytics } from "utils/analytics"

initAnalytics()

ReactDOM.render(
  <HelmetProvider>
    <ThemeConfig>
      <GlobalStyles />
      <HashRouter>
        <RootStoreProvider value={rootStore}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <ErrorBoundary
              FallbackComponent={ErrorFallback}
              onError={(error, info) => LoggingHelper.writeLog("index", "index", `${error ? JSON.stringify(error) : ""}`, LoggingLevel.Fatal)}
              onReset={() => {
                // reset the state of your app so the error doesn't happen again
              }}
            >
              <App />
            </ErrorBoundary>
          </LocalizationProvider>
        </RootStoreProvider>
      </HashRouter>
    </ThemeConfig>
  </HelmetProvider>,
  document.querySelector("#root"),
)
